/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { TestimonialContent } from '../../models/testimonial-content';

export interface ApiMasterTestimonialContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterTestimonialContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterTestimonialContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTestimonialContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TestimonialContent>>;
    })
  );
}

apiMasterTestimonialContentGetByCriteriaPost.PATH = '/api/Master/TestimonialContent/GetByCriteria';
